import { get } from 'lodash';
import { modifyAlpha } from '../../../utils/modifyColour';

export const styles = ({
   color,
   fontWeight,
   fontSize,
   fontStyle,
   margin,
   typography,
   padding,
  }) => ({
  pageHeaderDescriptionDivider: {
    marginBottom: `${get(margin, 'm10')}`,
  },
  pageHeader: {
    '&> div': {
      maxWidth: '100%',
      flexBasis: '100%',
      '&> div': {
        display: 'flex',
        flexDirection: 'column',
      },
    },
  },
  acceptBtn: {
    color: color.primaryButtonBackground,
  },
  actionBtn: {
    fontSize: fontSize.bodyText,
    fontWeight: fontWeight.normal,
    height: 20,
  },
  alertMessageClass: {
    padding: '6px 0 !important',
    width: '540px !important',
  },
  alertMessageContainerClass: {
    margin: '0 0 !important',
  },
  alertMessageHeaderContainerClass: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  alertMessageLeftHeaderClass: {
    color: modifyAlpha(color.bodyText, 0.7),
    fontFamily: typography.bodyText,
    fontSize:fontSize.bodyText,
    fontStyle: fontStyle.normal,
    fontWeight: fontWeight.bold,
  },
  alertMessageRightHeaderClass: {
    color: modifyAlpha(color.bodyText, 0.7),
    fontFamily: typography.bodyText,
    fontSize:fontSize.bodyText,
    fontStyle: fontStyle.normal,
    fontWeight: fontWeight.normal,
  },
  alertMessageMaxLengthWarningClass: {
    color: modifyAlpha(color.bodyText, 0.7),
    fontFamily: typography.smallText,
    fontSize:fontSize.smallText,
    fontStyle: fontStyle.normal,
    fontWeight: fontWeight.normal,
  },
  nameFieldContainer: {
    margin: `${get(margin, 'm0')} !important`,
    marginRight: '5px !important',
  },
  fieldContainer: {
    margin: `${get(margin, 'm0')} !important`,
    marginRight: '8px !important',
  },
  emailTypeContainerClass : {
    margin: `${get(margin, 'm0')} !important`,
  },
  emailTypeFieldClass: {
    borderTopRightRadius : 0,
    borderBottomRightRadius : 0,
  },
  emailFieldClass: {
    [`& fieldset`]: {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius : 0,
    },
  },
  rejectBtn: {
    color: color.error,
  },
  rejectSubmitButton: {
    backgroundColor: `${color.error} !important`,
    borderColor: `${color.error} !important`,
  },
  pageFilterAndSortClass: {
    justifyContent: 'left',
  },
  bulkActionRejectButton: {
    backgroundColor: get(color, 'error'),
    borderColor: get(color, 'error'),
    margin: `0 ${get(margin, 'm2')}`,
    '&:hover': {
      backgroundColor: get(color, 'errorHover'),
    },
  },
  bulkActionAcceptButton: {
    margin: `0 ${get(margin, 'm2')}`,
  },
  actionsFieldContainer : {
    marginBottom : get(margin, 'm15'),
  },
  actionsLabel : {
    padding : get(padding, 'p4'),
  },
  checkBoxContainer : {
    display : 'flex',
    alignItems : 'center',
  },
  assignOrgRole : {
    marginLeft: 25,
  },
  /* Alert Message Classes */
  alertMessages: {
    minWidth: 'fit-content',
    width : 'max-content',
    left: '35% !important',
    backgroundColor: get(color, 'white'),
    color: get(color, 'black'),
    fontWeight: 800,
    '& .MuiSnackbarContent-message': {
      width: 'fit-content',
    },
  },
  alertMessagesCloseButton : {
    color : "#114599",
  },
  fieldContainerClass : {
    marginTop : `${get(margin, 'm10')} !important`,
    marginBottom : `${get(margin, 'm10')} !important`,
    '& .MuiTextField-root' : {
      paddingTop : get(padding, 'p0'),
      paddingBottom : get(padding, 'p0'),
    },
    '& .MuiInputBase-root' : {
      marginTop : get(margin, 'm5'),
    },
    '& .Mui-disabled' : {
      borderColor : get(color, 'gray'),
      backgroundColor : get(color, 'gray'),
    },
    '& .Mui-disabled:hover' : {
      borderColor : get(color, 'gray'),
    },
  },
  alertDialogErrorMessagesClass : {
    width: '100%',
    overflow: 'auto',
    maxHeight: 300,
  },
  dateRangeContainerClass : {
    marginTop: get(margin, 'm30'),
  },
});

export default styles;
